import { useMemo } from 'react';

const getUniqueId = () => {
  const dateString = Date.now().toString(36);
  const randomness = Math.random().toString(36).substring(2);
  return dateString + randomness;
};

const useId = () => {
  return useMemo(() => getUniqueId(), []);
};

export default useId;
